"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCartesianUpdateHooks = void 0;
/**
 * @public
 * Canvas update hook, called before and after a plot is drawn.
 */
class CanvasCartesianUpdateHooks {
    constructor(getDrawRange) {
        this.getDrawRange = getDrawRange;
    }
    onAfterUpdate(renderer) {
        renderer.sharedState.updateScissorRange(null);
    }
    onBeforeUpdate(renderer, arg) {
        renderer.sharedState.updateScissorRange(this.getDrawRange(arg));
    }
}
exports.CanvasCartesianUpdateHooks = CanvasCartesianUpdateHooks;
//# sourceMappingURL=canvas-cartesian-update-hooks.js.map